import {
  ApiDataAccess,
  Dictionary, HttpApiRepository,
} from '@softline/core';
import {
  PatchProductDescriptionItem,
  ProductDescription,
} from '../types/product-description';
import { SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_DESCRIPTION } from '../artikelstamm.api';
import { ProductQuery } from '../types/product.query';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class ProductDescriptionRepository extends HttpApiRepository<ProductDescription, ProductDescription, ProductQuery, ProductQuery> {

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_DESCRIPTION);
  }

  override getCRUDPathParams(params: ProductQuery): Dictionary<unknown> {
    return { id: params.id };
  }

  save(data: PatchProductDescriptionItem): Promise<ProductDescription> {
    return this.dataAccess.patch({
      path: SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_DESCRIPTION,
      pathParams: { id: data.id },
    },
      {
        field: data.field,
        content: data.content,
        language: data.language,
      })
  }
}
